/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Form_LabelInputs */

const en_options_editor_form_label = /** @type {(inputs: Options_Editor_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editor Settings`)
};

const fr_options_editor_form_label = /** @type {(inputs: Options_Editor_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paramètres de l'éditeur`)
};

const de_options_editor_form_label = /** @type {(inputs: Options_Editor_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editor-Einstellungen`)
};

const it_options_editor_form_label = /** @type {(inputs: Options_Editor_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impostazioni dell'editor`)
};

const ru_options_editor_form_label = /** @type {(inputs: Options_Editor_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройки редактора`)
};

const es_options_editor_form_label = /** @type {(inputs: Options_Editor_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuración del editor`)
};

const zh_cn2_options_editor_form_label = /** @type {(inputs: Options_Editor_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编辑器设置`)
};

const ja_options_editor_form_label = /** @type {(inputs: Options_Editor_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エディター設定`)
};

const hi_options_editor_form_label = /** @type {(inputs: Options_Editor_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संपादक सेटिंग्स`)
};

const pt_pt2_options_editor_form_label = /** @type {(inputs: Options_Editor_Form_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configurações do editor`)
};

/**
* | output |
* | --- |
* | "Editor Settings" |
*
* @param {Options_Editor_Form_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_form_label = /** @type {((inputs?: Options_Editor_Form_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Form_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_editor_form_label(inputs)
	if (locale === "de") return de_options_editor_form_label(inputs)
	if (locale === "it") return it_options_editor_form_label(inputs)
	if (locale === "ru") return ru_options_editor_form_label(inputs)
	if (locale === "es") return es_options_editor_form_label(inputs)
	if (locale === "zh-CN") return zh_cn2_options_editor_form_label(inputs)
	if (locale === "ja") return ja_options_editor_form_label(inputs)
	if (locale === "hi") return hi_options_editor_form_label(inputs)
	if (locale === "pt-PT") return pt_pt2_options_editor_form_label(inputs)
	return en_options_editor_form_label(inputs)
});